import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function SubscriptionCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50/30 via-white to-teal-50/20 flex items-center justify-center p-6">
      <motion.div 
        className="max-w-md w-full text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl border border-amber-100 p-8 shadow-lg">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-amber-100 flex items-center justify-center">
            <XCircle className="w-10 h-10 text-amber-600" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-3">Subscription Cancelled</h1>
          <p className="text-slate-600 mb-6">
            No worries! You can subscribe anytime to unlock all premium features.
          </p>
          <div className="space-y-3">
            <Button 
              onClick={() => navigate("/auth")}
              className="w-full bg-teal-500 hover:bg-teal-600 text-white py-6 font-semibold"
            >
              Try Again
            </Button>
            <Button 
              variant="ghost"
              onClick={() => navigate("/")}
              className="w-full text-slate-600"
            >
              Back to Home
            </Button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
